// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SGtYs","rootNoMargin":"styles_rootNoMargin__-57u5"};